
// import React, { useState } from "react";
// import Detoxificationimg from "../../assets/Homepage/ServicesDesktop/Detoxification.png";
// import IndividualTherapyimg from "../../assets/Homepage/ServicesDesktop/IndividualTherapy.png";
// import GroupTherapyimg from "../../assets/Homepage/ServicesDesktop/GroupTherapy.png";
// import FamilyTherapyimg from "../../assets/Homepage/ServicesDesktop/FamilyTherapy_.png";
// import MedicationManagementimg from "../../assets/Homepage/ServicesDesktop/MedicationManagement.png";
// import HolisticTherapiesimg from "../../assets/Homepage/ServicesDesktop/HolisticTherapies.png";
// import AftercarePlanningimg from "../../assets/Homepage/ServicesDesktop/AftercarePlanning.png";
// import Educationandworkshopsimg from "../../assets/Homepage/ServicesDesktop/Educationandworkshops.png";
// import PeerSupportGroupsimg from "../../assets/Homepage/ServicesDesktop/PeerSupportGroups.png";

// import buttonarrowactive from "../../assets/Buttonarrow.svg";
// import buttonarrowinactive from "../../assets/Buttoninactive.svg";

// const servicesData = [
//   { title: "Detoxification", desc: "Our medically supervised detox program ensures a safe and comfortable withdrawal process, helping individuals clear substances from their body under expert care.", img: Detoxificationimg },
//   { title: "Individual Therapy", desc: "Personalized one-on-one counseling sessions address the unique challenges of each client, fostering self-awareness, emotional healing, and long-term change.", img: IndividualTherapyimg },
//   { title: "Group Therapy", desc: "Supportive group sessions provide a space to share experiences, gain perspective, and build connections with others on similar recovery journeys.", img: GroupTherapyimg },
//   { title: "Family Therapy", desc: "We involve loved ones in the healing process, helping families understand addiction, improve communication, and rebuild trust together.", img: FamilyTherapyimg },
//   { title: "Medication Management", desc: "Our medical professionals prescribe and monitor necessary medications to support recovery, manage symptoms, and prevent relapse.", img: MedicationManagementimg },
//   { title: "Holistic Therapies", desc: "Through yoga, meditation, art, and music therapy, we nurture mental, emotional, and physical well-being, complementing traditional treatments.", img: HolisticTherapiesimg },
//   { title: "Aftercare Planning", desc: "We design personalized aftercare plans to ensure continued support and strategies for maintaining sobriety after leaving rehab.", img: AftercarePlanningimg },
//   { title: "Education and workshops", desc: "Interactive sessions provide knowledge on addiction, relapse prevention, and essential life skills to empower clients for the future.", img: Educationandworkshopsimg },
//   { title: "Peer Support Groups", desc: "We connect clients with others who have faced similar struggles, creating a community of understanding, encouragement, and mutual growth.", img: PeerSupportGroupsimg },
// ];

// const Services = () => {
//   const [activeIndex, setActiveIndex] = useState(0);

//   return (
//     <section className="bg-gradient-to-b from-[#FFFFFF] to-[#E6E7F8] py-16">
//       {/* Heading + Description */}
//       <div className="grid grid-cols-12 gap-6 px-6 md:px-20 lg:px-[75px]">
//         <div className="col-span-12">
//           <h1 className="font-garamond-heading md:text-[100px] text-[32px] font-normal text-[#2C3075] leading-tight">
//             Arambh is more than just recovery it’s a new way of life.
//           </h1>
//         </div>
//         <div className="col-span-12 md:col-span-6 border-t-2 border-[#2C3075]">
//           <p className="font-generalsans-description pt-4 text-[#2C3075] font-normal md:text-[20px] leading-[110%] text-[14px]">
//             At Arambh Rehab, we go beyond addressing addiction — we focus on
//             healing the whole person. Our wide range of services is designed to
//             support physical, emotional, and psychological well-being at every
//             stage of recovery. From medically supervised detox and personalized
//             therapy to holistic practices like yoga and meditation, we provide
//             the tools and guidance needed to rebuild a healthier, more
//             fulfilling life.
//           </p>
//         </div>
//       </div>

//       {/* Services List & Image */}
//       <div className="grid grid-cols-12 gap-8 mt-12 px-6 md:px-20 lg:px-[75px]">
//         {/* Services List */}
//         <div className="col-span-12 md:col-span-6 font-generalsans-subheading text-[#2C3075] font-normal md:text-[20px] leading-[110%] text-[14px]">
//           {servicesData.map((service, index) => {
//             const isActive = activeIndex === index;
//             return (
//               <div
//                 key={index}
//                 onMouseEnter={() => setActiveIndex(index)}
//                 className="cursor-pointer mb-6"
//               >
//                 <div
//                   className={`flex items-center justify-between border-b-2 py-[24px] transition-colors duration-300 ${
//                     isActive
//                       ? "text-aarambh-dark border-aarambh-dark"
//                       : "text-[#2C30755E] border-transparent"
//                   } hover:text-aarambh-dark hover:border-aarambh-dark`}
//                 >
//                   <h3
//                     className={`md:text-[32px] text-[24px] transition-transform duration-300 ${
//                       isActive
//                         ? "translate-x-[20px]"
//                         : "hover:translate-x-[20px]"
//                     }`}
//                   >
//                     {service.title}
//                   </h3>
//                   <img
//                     src={isActive ? buttonarrowactive : buttonarrowinactive}
//                     alt="arrow"
//                     className="w-8 h-8 transition-all duration-300"
//                   />
//                 </div>
//               </div>
//             );
//           })}
//         </div>

//         {/* Sticky Image + Description */}
//         <div className="hidden md:block col-span-6">
//           <div className="sticky top-0">
//             <div className="w-[410px] ml-auto bg-white rounded-t-[200px] shadow-lg flex flex-col items-center pt-6 px-4 pb-6">
//               <div className="w-72 h-[460px] bg-gray-200 rounded-full overflow-hidden">
//                 <img
//                   src={servicesData[activeIndex].img}
//                   alt={servicesData[activeIndex].title}
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//               <div className="mt-4 mx-4 text-[18px] font-generalsans-description text-[#2C3075] font-normal text-center">
//                 <p>{servicesData[activeIndex].desc}</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Services;


import React, { useEffect, useState } from "react";
import Detoxificationimg from "../../assets/Homepage/ServicesDesktop/Detoxification.png";
import IndividualTherapyimg from "../../assets/Homepage/ServicesDesktop/IndividualTherapy.png";
import GroupTherapyimg from "../../assets/Homepage/ServicesDesktop/GroupTherapy.png";
import FamilyTherapyimg from "../../assets/Homepage/ServicesDesktop/FamilyTherapy_.png";
import MedicationManagementimg from "../../assets/Homepage/ServicesDesktop/MedicationManagement.png";
import HolisticTherapiesimg from "../../assets/Homepage/ServicesDesktop/HolisticTherapies.png";
import AftercarePlanningimg from "../../assets/Homepage/ServicesDesktop/AftercarePlanning.png";
import Educationandworkshopsimg from "../../assets/Homepage/ServicesDesktop/Educationandworkshops.png";
import PeerSupportGroupsimg from "../../assets/Homepage/ServicesDesktop/PeerSupportGroups.png";

import buttonarrowactive from "../../assets/Buttonarrow.svg";
import buttonarrowinactive from "../../assets/Buttoninactive.svg";

const servicesData = [
  { title: "Detoxification", desc: "Our medically supervised detox program ensures a safe and comfortable withdrawal process, helping individuals clear substances from their body under expert care.", img: Detoxificationimg },
  { title: "Individual Therapy", desc: "Personalized one-on-one counseling sessions address the unique challenges of each client, fostering self-awareness, emotional healing, and long-term change.", img: IndividualTherapyimg },
  { title: "Group Therapy", desc: "Supportive group sessions provide a space to share experiences, gain perspective, and build connections with others on similar recovery journeys.", img: GroupTherapyimg },
  { title: "Family Therapy", desc: "We involve loved ones in the healing process, helping families understand addiction, improve communication, and rebuild trust together.", img: FamilyTherapyimg },
  { title: "Medication Management", desc: "Our medical professionals prescribe and monitor necessary medications to support recovery, manage symptoms, and prevent relapse.", img: MedicationManagementimg },
  { title: "Holistic Therapies", desc: "Through yoga, meditation, art, and music therapy, we nurture mental, emotional, and physical well-being, complementing traditional treatments.", img: HolisticTherapiesimg },
  { title: "Aftercare Planning", desc: "We design personalized aftercare plans to ensure continued support and strategies for maintaining sobriety after leaving rehab.", img: AftercarePlanningimg },
  { title: "Education and workshops", desc: "Interactive sessions provide knowledge on addiction, relapse prevention, and essential life skills to empower clients for the future.", img: Educationandworkshopsimg },
  { title: "Peer Support Groups", desc: "We connect clients with others who have faced similar struggles, creating a community of understanding, encouragement, and mutual growth.", img: PeerSupportGroupsimg },
];

const Services = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth < 768);
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <section className="bg-gradient-to-b from-[#FFFFFF] to-[#E6E7F8] py-16">
      {/* Heading + Description */}
      <div className="grid grid-cols-12 gap-6 px-6 md:px-20 lg:px-[75px]">
        <div className="col-span-12">
          <h1 className="font-garamond-heading md:text-[100px] text-[32px] font-normal text-[#2C3075] leading-tight">
            Arambh is more than just recovery it’s a new way of life.
          </h1>
        </div>
        <div className="col-span-12 md:col-span-6 border-t-2 border-[#2C3075]">
          <p className="font-generalsans-description pt-4 text-[#2C3075] font-normal md:text-[20px] leading-[110%] text-[14px]">
            At Arambh Rehab, we go beyond addressing addiction — we focus on
            healing the whole person. Our wide range of services is designed to
            support physical, emotional, and psychological well-being at every
            stage of recovery. From medically supervised detox and personalized
            therapy to holistic practices like yoga and meditation, we provide
            the tools and guidance needed to rebuild a healthier, more
            fulfilling life.
          </p>
        </div>
      </div>

      {/* Services List & Image */}
      <div className="grid grid-cols-12 gap-8 mt-12 px-6 md:px-20 lg:px-[75px]">
        {/* Services List */}
        <div className="col-span-12 md:col-span-6 font-generalsans-subheading text-[#2C3075] font-normal md:text-[20px] leading-[110%] text-[14px]">
          {servicesData.map((service, index) => {
            // Force all active in mobile
            const isActive = isMobile ? true : activeIndex === index;

            return (
              <div
                key={index}
                onMouseEnter={() => !isMobile && setActiveIndex(index)} // only hover on desktop
                className="cursor-pointer mb-6"
              >
                <div
                  className={`flex items-center justify-between border-b-2 py-[24px] transition-colors duration-300 ${
                    isActive
                      ? "text-aarambh-dark border-aarambh-dark"
                      : "text-[#2C30755E] border-transparent"
                  } hover:text-aarambh-dark hover:border-aarambh-dark`}
                >
                  <h3
                    className={`md:text-[32px] text-[24px] transition-transform duration-300 ${
                      isActive
                        ? "translate-x-[20px]"
                        : "hover:translate-x-[20px]"
                    }`}
                  >
                    {service.title}
                  </h3>
                  <img
                    src={isActive ? buttonarrowactive : buttonarrowinactive}
                    alt="arrow"
                    className="w-8 h-8 transition-all duration-300"
                  />
                </div>
              </div>
            );
          })}
        </div>

        {/* Sticky Image + Description */}
        <div className="hidden md:block col-span-6">
          <div className="sticky top-0">
            <div className="w-[410px] ml-auto bg-white rounded-t-[200px] shadow-lg flex flex-col items-center pt-6 px-4 pb-6">
              <div className="w-72 h-[460px] bg-gray-200 rounded-full overflow-hidden">
                <img
                  src={servicesData[activeIndex].img}
                  alt={servicesData[activeIndex].title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="mt-4 mx-4 text-[18px] font-generalsans-description text-[#2C3075] font-normal text-center">
                <p>{servicesData[activeIndex].desc}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
